import type { DocPabean } from "./models/doc-pabean-model";

const DEMO_BASE_DOC_PABEANS: DocPabean[] = [
  {
    id: 9213,
    batchUUID: "e5744679-4f25-40df-8eb5-7518e0e9451b",
    idHeader: "bc797786-63a9-4a53-a300-3f564d20745b",
    nomorAju: "00002020201920251016220390",
    nomorDaftar: null,
    tanggalDaftar: "2025-10-16",
    createdAt: "2025-10-16T10:30:00Z",
    namaEntitas: "Demo Global Industries",
    namaProses: "Perekaman Dokumen",
    namaPerusahaan: "Demo Global Industries",
    drafterName: "Alex Demo",
    totalItem: 1,
    shipperConsigneeCountry: "Italy",
    motType: "SEA",
    buyerName: "Demo Global Industries",
    consigneeName: null,
    approvalStatus: null,
    approvalDate: null,
  },
  {
    id: 9209,
    batchUUID: "d63c4b71-26ed-4dee-8219-e9b1498ee829",
    idHeader: "5c98cf77-9b6b-4855-b986-4775c619eeb7",
    nomorAju: "00002020201920251016210543",
    nomorDaftar: null,
    tanggalDaftar: "2025-10-16",
    createdAt: "2025-10-16T08:15:00Z",
    namaEntitas: "Demo Oceanic Trading",
    namaProses: "SPPB",
    namaPerusahaan: "Demo Oceanic Trading",
    drafterName: "Bianca Demo",
    totalItem: 1,
    shipperConsigneeCountry: "China",
    motType: "SEA",
    buyerName: "Demo Oceanic Trading",
    consigneeName: null,
    approvalStatus: null,
    approvalDate: null,
  },
  {
    id: 9206,
    batchUUID: "e004aba2-8b7c-426d-8b26-7705ee4e5fe8",
    idHeader: "588eb5e9-59a6-47fd-9c1b-bebeaf2afd2d",
    nomorAju: "00002020201920251016220392",
    nomorDaftar: null,
    tanggalDaftar: "2025-10-16",
    createdAt: "2025-10-15T14:45:00Z",
    namaEntitas: "Demo Precision Manufacturing",
    namaProses: "SPPB",
    namaPerusahaan: "Demo Precision Manufacturing",
    drafterName: "Charlie Demo",
    totalItem: 2,
    shipperConsigneeCountry: "United Kingdom",
    motType: "SEA",
    buyerName: "Demo Precision Manufacturing",
    consigneeName: null,
    approvalStatus: null,
    approvalDate: null,
  },
  {
    id: 9205,
    batchUUID: "47fa888d-81dc-45f7-87a6-0acf49a41d0f",
    idHeader: "9e47abe3-ad2f-43a2-85b6-b4df1813a525",
    nomorAju: "00002020201920251016210542",
    nomorDaftar: null,
    tanggalDaftar: "2025-10-16",
    createdAt: "2025-10-14T09:20:00Z",
    namaEntitas: "Demo Horizon Logistics",
    namaProses: "Perekaman Dokumen",
    namaPerusahaan: "Demo Horizon Logistics",
    drafterName: "Devon Demo",
    totalItem: 12,
    shipperConsigneeCountry: "Vietnam",
    motType: "SEA",
    buyerName: "Demo Horizon Logistics",
    consigneeName: null,
    approvalStatus: null,
    approvalDate: null,
  },
  {
    id: 9201,
    batchUUID: "422b5a62-c2c9-4abc-afb2-473234756032",
    idHeader: "8668ac78-7611-4792-96ba-80e9624b8992",
    nomorAju: "00002020201920251016210541",
    nomorDaftar: null,
    tanggalDaftar: "2025-10-16",
    createdAt: "2025-10-13T16:00:00Z",
    namaEntitas: "Demo Stellar Imports",
    namaProses: "BILLING",
    namaPerusahaan: "Demo Stellar Imports",
    drafterName: "Emerson Demo",
    totalItem: 4,
    shipperConsigneeCountry: "China",
    motType: "SEA",
    buyerName: "Demo Stellar Imports",
    consigneeName: null,
    approvalStatus: null,
    approvalDate: null,
  },
  {
    id: 9197,
    batchUUID: "0369f772-e48c-4d7c-98a5-f6e3c7088e31",
    idHeader: "8d158dde-2c6d-4b1d-ac16-110c328e1cb6",
    nomorAju: "00002020201920251016310257",
    nomorDaftar: null,
    tanggalDaftar: "2025-10-16",
    createdAt: "2025-10-12T11:30:00Z",
    namaEntitas: "Demo Tech Components",
    namaProses: "Perekaman Dokumen",
    namaPerusahaan: "Demo Tech Components",
    drafterName: "Harper Demo",
    totalItem: 34,
    shipperConsigneeCountry: "Japan",
    motType: "SEA",
    buyerName: "Demo Tech Components",
    consigneeName: null,
    approvalStatus: null,
    approvalDate: null,
  },
  {
    id: 9177,
    batchUUID: "5dc8bfb2-4efc-4e5a-90ff-c8932c969cf6",
    idHeader: "7d3a29da-eaf6-470d-afe6-b827a28c1a2a",
    nomorAju: "00002020201920251015220389",
    nomorDaftar: null,
    tanggalDaftar: "2025-10-15",
    createdAt: "2025-10-10T07:45:00Z",
    namaEntitas: "Demo Precision Manufacturing",
    namaProses: "SPPB",
    namaPerusahaan: "Demo Precision Manufacturing",
    drafterName: "Casey Demo",
    totalItem: 10,
    shipperConsigneeCountry: "China",
    motType: "SEA",
    buyerName: "Demo Precision Manufacturing",
    consigneeName: null,
    approvalStatus: null,
    approvalDate: null,
  },
  {
    id: 9175,
    batchUUID: "ab450c26-27af-4579-8106-ef8fd74f98e1",
    idHeader: "5319195d-7d0a-4204-b6a5-82bb61b147a6",
    nomorAju: "00002020201920251015210540",
    nomorDaftar: null,
    tanggalDaftar: "2025-10-15",
    createdAt: "2025-10-08T13:20:00Z",
    namaEntitas: "Demo Stellar Imports",
    namaProses: "BILLING",
    namaPerusahaan: "Demo Stellar Imports",
    drafterName: "Jordan Demo",
    totalItem: 1,
    shipperConsigneeCountry: "China",
    motType: "SEA",
    buyerName: "Demo Stellar Imports",
    consigneeName: null,
    approvalStatus: null,
    approvalDate: null,
  },
  {
    id: 9174,
    batchUUID: "bd4bb945-de91-4233-aabe-ad4238e16fb4",
    idHeader: "ce022d07-9647-4c86-9bbf-5ddc394b7d50",
    nomorAju: "00002020201920251015210539",
    nomorDaftar: null,
    tanggalDaftar: "2025-10-15",
    createdAt: "2025-10-05T18:10:00Z",
    namaEntitas: "Demo Stellar Imports",
    namaProses: "Perekaman Dokumen",
    namaPerusahaan: "Demo Stellar Imports",
    drafterName: "Jordan Demo",
    totalItem: 2,
    shipperConsigneeCountry: "Malaysia",
    motType: "SEA",
    buyerName: "Demo Stellar Imports",
    consigneeName: null,
    approvalStatus: null,
    approvalDate: null,
  },
  {
    id: 9173,
    batchUUID: "aaf59da8-5267-4ace-a910-a598994c7dc4",
    idHeader: "72fa7c7d-0a6e-4afd-b09e-cc106329b132",
    nomorAju: "00002020201920251015210538",
    nomorDaftar: null,
    tanggalDaftar: "2025-10-15",
    createdAt: "2025-10-01T09:00:00Z",
    namaEntitas: "Demo Stellar Imports",
    namaProses: "Perekaman Dokumen",
    namaPerusahaan: "Demo Stellar Imports",
    drafterName: "Jordan Demo",
    totalItem: 1,
    shipperConsigneeCountry: "Malaysia",
    motType: "SEA",
    buyerName: "Demo Stellar Imports",
    consigneeName: null,
    approvalStatus: null,
    approvalDate: null,
  },
];

const DEMO_TOTAL_COUNT = 120;

const demoDocPabeanData: DocPabean[] = Array.from({ length: DEMO_TOTAL_COUNT }, (_, index) => {
  const template = DEMO_BASE_DOC_PABEANS[index % DEMO_BASE_DOC_PABEANS.length];
  const suffix = (index + 1).toString().padStart(4, "0");
  const baseAju = template.nomorAju.slice(0, -4);

  return {
    ...template,
    id: template.id + index * 100,
    batchUUID: `${template.batchUUID}-${suffix}`,
    idHeader: `${template.idHeader}-${suffix}`,
    nomorAju: `${baseAju}${suffix}`,
    totalItem: Math.max(1, template.totalItem + (index % 5)),
  };
});

export const isDemoUser = (): boolean => {
  if (typeof window === "undefined") {
    return false;
  }

  const authData = window.localStorage.getItem("authData");
  if (!authData) {
    return false;
  }

  try {
    const parsed = JSON.parse(authData);
    const email = parsed.email?.toLowerCase() || "";
    return email.includes("demo");
  } catch {
    return false;
  }
};

export const getDemoDocPabeans = (): DocPabean[] => demoDocPabeanData;

export const getDemoStatusHistory = (ajuNo: string) => {
  const record = demoDocPabeanData.find((item) => item.nomorAju === ajuNo);
  const reference = record ?? demoDocPabeanData[0];
  const baseDate = reference.tanggalDaftar ?? "2025-10-16";

  return {
    drafterName: reference?.drafterName ?? "Demo Drafter",
    companyName: reference?.namaPerusahaan ?? "Demo Company",
    ajuNo: record ? ajuNo : reference?.nomorAju ?? ajuNo,
    items: [
      {
        responseName: "DRAFT",
        responseTime: `${baseDate} 17:52:48`,
        leadTime: 0,
      },
      {
        responseName: "DRAFT SUBMITTED",
        responseTime: `${baseDate} 18:06:58`,
        leadTime: 850,
      },
    ],
  };
};
